import React, { Component } from 'react';
import GroupsComponent from 'components/mix/mix2/NewGroupsComponent.js';

class MixerDocumentation extends Component {
    constructor(props) {
        super(props);

        if (this.props.sequencerEngine.subSequences.length > 1) {
            this.props.sequencerEngine.switchToSubSequence(
                this.props.sequencerEngine.subSequences[1].id);
        }
    }

    componentWillUnmount() {
        this.props.sequencerEngine.switchToSubSequence(
            this.props.sequencerEngine.subSequences[0].id);
    }

    render() {
        return (
            <div>
              <p>
                Go to the <b>Mixer View</b> by clicking on the views dropdown at
                the top right of the page, and selecting “Mixer”.
              </p>
              <p>
                The <b>Mixer View</b> lets you see your track without any triggers, only faders
                and effects. This is desirable when mixing a track out, or
                jamming live. 
              </p>
              <p>
                Similar tracks are automatically grouped together by tags they have in common. 
                You can change the groups by dragging
                the individual tracks to other groups, or into a new group.
                <GroupsComponent sequencerEngine={this.props.sequencerEngine}/>
              </p>
              <p>
                You can apply effects to a group by selecting a group
                and adding effects at the bottom effects pane.
              </p>
              <p>
                <b>Keyboard shortcut</b>: "Tab" switches 
                between <b>Mixer View</b> and <b>Sequencer View</b>.
              </p>
            </div>
        );
    }
}

export default MixerDocumentation;
